<template>
  <div class="record">
    <el-form
      label-position="left"
      :inline="true"
      :model="orderForm"
      class="demo-form-inline"
    >
      <el-form-item label="导入日期">
        <el-col :span="11">
          <el-date-picker
            type="datetime"
            placeholder="开始日期"
            v-model="orderForm.starttime"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="datetime"
            placeholder="结束日期"
            v-model="orderForm.endtime"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="导入类型">
        <el-select
          v-model="orderForm.importtype"
          clearable
          placeholder="导入类型"
        >
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="searchGoodsList"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div class="border"></div>
    <el-table :data="stockPriceTableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="created_at" label="导入时间"></el-table-column>
      <el-table-column label="导入进度">
        <template slot-scope="scope">
          <div>{{ scope.row.status == "2" ? "导入完成" : "导入中" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="导入类型">
        <template slot-scope="scope">
          <div>{{ scope.row.type | importType }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="failed_count" label="导入结果">
        <template slot-scope="scope">
          <div v-if="scope.row.msg" style="color:red;">{{ scope.row.msg }}</div>
          <div v-else>
            {{
              scope.row.status == "2"
                ? "导入数量" +
                  scope.row.total_count +
                  "条,成功" +
                  scope.row.succeed_count +
                  "条,失败" +
                  scope.row.failed_count +
                  "条"
                : "导入中"
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="download(scope.$index, scope.row)"
            v-if="scope.row.file_path !== ''"
            >下载日志</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
  </div>
</template>
<script>
import { importList } from "@/models/goodsModel";
import { changeDateString } from "@/utils/utils";
export default {
  data() {
    return {
      orderForm: {
        starttime: "",
        endtime: "",
        importtype: "" // 筛选导入类型
      },
      typeList: [
        {
          name: "数量",
          id: 1
        },
        {
          name: "待审核价格",
          id: 2
        },
        {
          name: "库位",
          id: 3
        },
        {
          name: "取消选品导入",
          id: 4
        }
      ],
      currentPage: 1,
      pagesize: 20,
      totalCount: 0,
      stockPriceTableData: []
    };
  },
  mounted() {
    // 请求查询导入记录
    this.getImportList();
  },
  filters: {
    importType(val) {
      val += "";
      let text = "";
      switch (val) {
        case "1":
          text = "数量";
          break;
        case "2":
          text = "待审核价格";
          break;
        case "3":
          text = "库位";
          break;
        case "4":
          text = "取消选品导入";
          break;
        default:
          break;
      }
      return text;
    }
  },
  methods: {
    searchGoodsList() {
      this.currentPage = 1;
      this.getImportList();
    },
    async getImportList() {
      let params = {
        page: this.currentPage,
        starttime: "",
        endtime: "",
        type: this.orderForm.importtype,
        pagesize: this.pagesize
      };
      if (this.orderForm.starttime) {
        params.starttime = changeDateString(this.orderForm.starttime);
      }
      if (this.orderForm.endtime) {
        params.endtime = changeDateString(this.orderForm.endtime);
      }
      let data = await importList(params);
      this.totalCount = data.total;
      this.stockPriceTableData = data.list;
    },
    download(index, row) {
      if (row.file_path !== "") {
        window.location.href = row.file_path;
      }
    },
    // 分页数切换
    handleSizeChange(val) {
      this.pagesize = val;
      this.getImportList();
    },
    // 页面跳转
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getImportList();
    }
  }
};
</script>

<style lang="scss">
.record {
  .demo-form-inline {
    padding-bottom: 5px;
  }
  .border {
    height: 10px;
    border-top: 1px solid #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/stock/stock-record.vue